"use client";
import { isPrivateCapabilityPath } from "@/lib/booking/sharedBooking";
import { usePathname } from "next/navigation";
import { SpeedInsights } from "@vercel/speed-insights/next";
import { Analytics } from "@vercel/analytics/react";

export default function PublicAnalytics() {
  const path = usePathname();
  if (isPrivateCapabilityPath(path)) return null;
  return (
    <>
      <SpeedInsights />
      <Analytics
        beforeSend={(event) =>
          isPrivateCapabilityPath(new URL(event.url).pathname) ? null : event
        }
      />
    </>
  );
}
